'use client';

// Reads ?tool= and ?category= on the client: reading searchParams on the server would make the
// page dynamic for no gain.

import { useEffect, useState } from 'react';
import { ThreadComposer } from '@/components/community/CommunityForms';

export default function NewThreadClient() {
  const [preset, setPreset] = useState<{ tool?: string; category?: string } | null>(null);
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const tool = params.get('tool') ?? undefined;
    const category = params.get('category') ?? undefined;
    // eslint-disable-next-line react-hooks/set-state-in-effect
    setPreset({
      tool: tool && /^[a-z0-9-]{2,80}$/.test(tool) ? tool : undefined,
      category: category ?? (tool ? 'help' : undefined),
    });
  }, []);
  if (!preset) return null;
  return <ThreadComposer defaultCategory={preset.category} toolSlug={preset.tool} />;
}
